import React, { PropsWithChildren } from "react";

const XIcon = (props: PropsWithChildren<any>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
      style={{cursor:"pointer"}}
      {...props}
    >
      <path
        fill="#522398"
        d="M10.047 8l4.828-4.781.984-.985c.141-.14.141-.375 0-.562L14.83.64C14.64.5 14.405.5 14.265.64L8.5 6.453 2.687.641C2.547.5 2.313.5 2.125.64L1.094 1.67c-.14.188-.14.423 0 .563L6.906 8l-5.812 5.813c-.14.14-.14.374 0 .562l1.031 1.031c.188.14.422.14.563 0L8.5 9.594l4.781 4.828.985.984c.14.14.375.14.562 0l1.031-1.031c.141-.188.141-.422 0-.563L10.047 8z"
      ></path>
    </svg>
  );
};

export default React.memo(XIcon);
